<div class="spl-product-offer-info-card" *transloco="let t">
	<mat-card class="content">
		<mat-card-content>
			<div class="op-header-2-font">{{ t('ADJUST_TERMS.LOAN_TYPES.securedPersonalLoan') }}</div>
			<!-- Vehicle Info Display -->
			<div
				*ngIf="vehicleInfo?.make || vehicleInfo?.model || vehicleInfo?.year || vehicleInfo?.trim"
				class="op-mb-5 op-body-1-font vehicle-details"
			>
				<mat-icon svgIcon="op-vehicle" class="op-mr-5"></mat-icon>
				<span *ngIf="vehicleInfo?.year" class="op-mr-5">{{ vehicleInfo.year }}</span>
				<span *ngIf="vehicleInfo?.make" class="op-mr-5">{{ vehicleInfo.make }}</span>
				<span *ngIf="vehicleInfo?.model" class="op-mr-5">{{ vehicleInfo.model }}</span>
				<span *ngIf="vehicleInfo?.trim" class="op-mr-5">({{ vehicleInfo.trim }})</span>
			</div>
			<div *ngIf="vehicleInfo?.vinLast5" class="op-mb-8 op-body-1-font">
				<span class="op-ml-30">{{ t('VEHICLE.last5VIN', { vinLast5: vehicleInfo.vinLast5 }) }}</span>
			</div>
			<div class="loan-amount">
				<div class="op-header-4-font" [innerHTML]="t('OFFER_STATUS.upTo')"></div>
				<div class="op-display-2-font">
					{{ splMaxLoanAmount | currency: 'USD':'symbol':'0.0' }}
					<sup>*</sup>
				</div>
			</div>
			<div class="op-mt-20 op-mb-16" *ngIf="showSkipSPLOfferButton">
				<button mat-flat-button color="secondary-small" id="splSkipOfferBtn" (click)="onContinue()">
					{{ skipOfferButtonText }}
				</button>
			</div>
		</mat-card-content>
	</mat-card>
</div>
